import { render, staticRenderFns } from "./SkuPropertiesDisplay.vue?vue&type=template&id=5055a1be&scoped=true&"
import script from "./SkuPropertiesDisplay.vue?vue&type=script&lang=ts&"
export * from "./SkuPropertiesDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SkuPropertiesDisplay.vue?vue&type=style&index=0&id=5055a1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055a1be",
  null
  
)

export default component.exports